module.exports = __webpack_public_path__ + "static/media/cold.a4777537.svg";